<template>
  <div
    class="c-route-bar"
    :class="{
      'c-route-bar--inactive': inactive,
      'c-route-bar--ov': mode === 'ov',
      'c-route-bar--train': mode === 'train',
      'c-route-bar--walk': mode === 'walk',
      'c-route-bar--start': mode === 'start',
      'c-route-bar--destination': mode === 'destination'
    }"
    :style="{
      width: width ? `${width}%` : null
    }"
  >
    <div
      class="c-route-bar__icon"
      v-if="icon"
    >
      <o-icon :icon="icon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ORouteBar',
  props: {
    mode: {
      type: String,
      default: 'walk'
    },
    icon: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: 'auto'
    },
    inactive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-route-bar {
  flex: 1 1 auto;
  position: relative;

  &:not(:last-child) {
    margin-right: 0.8rem;
  }

  &:before {
    background: $primary-color;
    background: var(--primary-color);
    border-radius: 0.2rem;
    content: '';
    height: 0.4rem;
    left: 0;
    position: absolute;
    top: calc(50% - 0.2rem);
    right: 0;
  }
}

.c-route-bar--inactive {
  opacity: 0.7;
}

.c-route-bar--start,
.c-route-bar--destination {
  align-items: center;
  background-color: $gray-100;
  border-radius: 1.2rem;
  display: flex;
  flex: none;
  font-size: 1.2rem;
  font-weight: 600;
  justify-content: center;
  line-height: 1;
  width: 2.4rem;

  &:before {
    display: none;
  }

  &:after {
    content: 'A'
  }
}

.c-route-bar--destination:after {
  content: 'B'
}

.c-route-bar__icon {
  background: $primary-color;
  background: var(--primary-color);
  border-radius: 1.2rem;
  color: #FFF;
  display: inline-flex;
  padding: 0.4rem;
  position: relative;
  z-index: 1;

  .c-icon {
    height: 1.6rem;
    width: 1.6rem;
  }
}

.c-route-bar--ov {
  &:before,
  .c-route-bar__icon {
    background-color: #e2c000;
  }
}

.c-route-bar--train {
  &:before,
  .c-route-bar__icon {
    background-color: #0026a3;
  }
}

.c-route-bar--walk {
  &:before,
  .c-route-bar__icon {
    background-color: $blue;
  }
}
</style>
